import request from '@/utils/request'

// 冷链药房预警数据查询
export function thePharmacyWarning(data) {
    return request({
        url: '/api/drugstore/warning-data-query',
        method: 'post',
        data
    })
}

// 冷链药房实时数据查询  /api/drugstore/real-time-data-query
export function thePharmacyInRealTime(data) {
    return request({
        url: '/api/drugstore/real-time-data-query',
        method: 'post',
        data
    })
}



